import { isEqual } from 'lodash';
import { useCallback, useEffect } from 'react';

import { usePrevious } from '@hivebrite/react-hooks';

import useTopics from './useTopics';
import useTopicsMenuName from './useTopicsMenuName';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import reduceParams from '../utils/reduceParams';

const useTopicsFilteredTopics = () => {
  const { filters } = useTopicsIndexContext();
  const params = {};
  const {
    topics,
    totalTopics,
    isFetchingTopics,
    setPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopics({ params, isAutomaticallyFetched: false });
  const name = useTopicsMenuName();
  const query = reduceParams(filters.query);

  const prevFilters = usePrevious(filters);

  const loadNextPage = useCallback(() => {
    setPage((previousPage) => {
      const page = previousPage + 1;

      handleFetchTopics({ page, ...query });

      return page;
    });
  }, []);

  useEffect(() => {
    if (!isEqual(prevFilters, filters)) {
      handleFetchTopics({ page: 1, resetTopics: true, ...query });
    }
  }, [filters]);

  return {
    name,
    topics,
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  };
};

export default useTopicsFilteredTopics;
